import { connect } from 'react-redux';

import { postOnboardingAnswers, setDiet } from '../../actions/';

import Onboarding, { Mode } from '../components/Onboarding';

const mapStateToProps = state => ({
  mode: Mode.EXISTING_USER,
});

const mapDispatchToProps = {
  postOnboardingAnswers,
  setDiet
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Onboarding)
